import routes from '@modules/season/season-routes';
import store from '@modules/season/season-store';

export default {
  routes,
  store,
};
